module.exports = __webpack_public_path__ + "img/pms-item-placeholder.289297bc.jpg";